export default __webpack_public_path__ + "static/media/keto-chocolate-bar@3x.23fbc6b3.png";